module.exports = __webpack_public_path__ + "static/media/p208g3.2a4bf95a.jpg";